<template>
  <div ref="dropdownElem" v-clickout="triggerClose" class="gfr-dropdown" @click="triggerOpen">
    <slot />
  </div>
</template>
<script lang="ts" setup>
import './styles/index.scss'
import { getBoundingClientRect } from '~/components/gfr/utils'
import { rectInfo } from '~/components/gfr/utils/types'
const open = ref(false)
const dropdownElem = ref<HTMLElement>()
const rect = ref<null | rectInfo>(null)
function triggerClose() {
  open.value = false
}
function triggerOpen() {
  open.value = !open.value
  !rect.value && updateRect()
}
function updateRect() {
  rect.value = getBoundingClientRect(dropdownElem.value as HTMLElement)
}
// 通过依赖注入
provide('open', open)
provide('rect', rect)
provide('triggerClose', triggerClose)
/* Open State */
watch(
  () => open.value,
  (val) => {
    if (val) {
      updateRect()
      window.addEventListener('resize', updateRect)
      window.addEventListener('scroll', throttle(updateRect, 10))
    } else {
      window.removeEventListener('resize', updateRect)
      window.removeEventListener('scroll', throttle(updateRect, 10))
    }
  }
)
onMounted(() => {})
onUnmounted(() => {
  window.removeEventListener('resize', updateRect)
  window.removeEventListener('scroll', throttle(updateRect, 10))
})
</script>
<style>
:root {
  --transform-top: 80px;
}
</style>
